import Model from "./Model";

class Message extends Model {
    getId() {
        return this.attrs.id;
    }
    
    setId(value) {
        this.attrs.id = value;
        return this;
    }

     getTemplateId() {
        return this.attrs.templateId;
    }
    
    setTemplateId(value) {
        this.attrs.templateId = value;
        return this;
    }

    getServiceId() {
        return this.attrs.serviceId;
    }
    
    setServiceId(value) {
        this.attrs.serviceId = value;
        return this;
    }

    getTemplateName() {
        return this.attrs.templateName;
    }
    
    setTemplateName(value) {
        this.attrs.templateName = value;
        return this;
    }
     getCategory() {
        return this.attrs.category;
    }
    
    setCategory(value) {
        this.attrs.category = value;
        return this;
    }

    getBody() {
        return this.attrs.body;
    }
    
    setBody(value) {
        this.attrs.body = value;
        return this;
    }

    getCopyCodeLabel() {
        return this.attrs.copyCodeLabel;
    }
    
    setCopyCodeLabel(value) {
        this.attrs.copyCodeLabel = value;
        return this;
    }
     getCtaButtons() {
        return this.attrs.ctaButtons;
    }
    
    setCtaButtons(value) {
        this.attrs.ctaButtons = value;
        return this;
    }

    getFooter() {
        return this.attrs.footer;
    }
    
    setFooter(value) {
        this.attrs.footer = value;
        return this;
    }

    getHeaderText() {
        return this.attrs.headerText;
    }
    
    setHeaderText(value) {
        this.attrs.headerText = value;
        return this;
    }
    getHeaderType() {
        return this.attrs.headerType;
    }
    
    setHeaderType(value) {
        this.attrs.headerType = value;
        return this;
    }
     getHeaderMedia() {
        return this.attrs.headerMedia;
    }
    
    setHeaderMedia(value) {
        this.attrs.headerMedia = value;
        return this;
    }

    getHeaderMediaType() {
        return this.attrs.headerMediaType;
    }
    
    setHeaderMediaType(value) {
        this.attrs.headerMediaType = value;
        return this;
    }

    getLanguage() {
        return this.attrs.language;
    }
    
    setLanguage(value) {
        this.attrs.language = value;
        return this;
    }
    getVariableSamples() {
        return this.attrs.variableSamples;
    }
    
    setVariableSamples(value) {
        this.attrs.variableSamples = value;
        return this;
    }
     getStatus() {
        return this.attrs.status;
    }
    
    setStatus(value) {
        this.attrs.status = value;
        return this;
    }

    getTemplateQualityScore() {
        return this.attrs.templateQualityScore;
    }

    setTemplateQualityScore(value) {
        this.attrs.templateQualityScore = value;
        return this;
    }

    getTemplateStatusReason() {
        return this.attrs.templateStatusReason;
    }

    setTemplateStatusReason(value) {
        this.attrs.templateStatusReason = value;
        return this;
    }

    getLocalOnly() {
        return !!this.attrs.localOnly;
    }
    getCreatedAt() {
        return this.attrs.createdAt;
    }
    
    setCreatedAt(value) {
        this.attrs.createdAt = value;
        return this;
    }
    getUpdatedAt() {
        return this.attrs.updatedAt;
    }
    
    setUpdatedAt(value) {
        this.attrs.updatedAt = value;
        return this;
    }
    getMediaUrl() {
        return this.attrs.mediaUrl;
    }
    
    setMediaUrl(value) {
        this.attrs.mediaUrl = value;
        return this;
    }
    getMediaId() {
        return this.attrs.mediaId;
    }
    
    setMediaId(value) {
        this.attrs.mediaId = value;
        return this;
    }

    getSourceDefaultTemplateId() {
        return this.attrs.sourceDefaultTemplateId;
    }

    setSourceDefaultTemplateId(value) {
        this.attrs.sourceDefaultTemplateId = value;
        return this;
    }

    getAppUsage() {
        const usages = this.getAppUsages();
        if (usages.includes("all")) return "all";
        return usages[0] || "draft";
    }

    setAppUsage(value) {
        this.setAppUsages(value);
        return this;
    }

    getAppUsages() {
        if (Array.isArray(this.attrs.appUsages) && this.attrs.appUsages.length) {
            return this.attrs.appUsages;
        }
        const single = this.attrs.appUsage || "draft";
        return [single];
    }

    setAppUsages(value) {
        const list = Array.isArray(value) ? value : [value || "draft"];
        this.attrs.appUsages = list;
        this.attrs.appUsage = list.includes("all") ? "all" : (list[0] || "draft");
        return this;
    }
}
export default Message;